import LayoutTableV2 from "./TableV2.presenter";
export default LayoutTableV2;
